var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.851,
    height: 79.867,
    viewBox: "0 0 89.851 79.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attention",
    transform: "translate(-19.072 -22.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    fill: "current",
    d: "M57.362,26.54,20.1,91.075a7.666,7.666,0,0,0,6.639,11.5h74.518a7.666,7.666,0,0,0,6.639-11.5L70.638,26.54a7.665,7.665,0,0,0-13.276,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1",
    "data-name": "Groupe 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 9.638,
    height: 29.377,
    rx: 4.333,
    transform: "translate(59.181 46.444)",
    fill: "#f56e52"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 4.819,
    cy: 4.819,
    r: 4.819,
    transform: "translate(59.181 82.609)",
    fill: "#f56e52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.7cc3bc1c8bc94059c910ff0936f94f12.svg";
export { ForwardRef as ReactComponent };